import { teamConstants as team } from "../../../constants/team";

const initialState = { loading: true, team: [], membre: null};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case team.GET_TEAM:
      return {
        ...state,
        loading: false,
        team: payload,
      };
    case team.GET_MEMBER:
      return {
        ...state,
        loading: false,
        membre: payload,
      };
    case team.SET_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
}